<script setup>
import { blownInsulation, drywall, screed } from '@/actions/App/Http/Controllers/ServiceController'
import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline'

const features = [
    {
        id: 'montaze-sadrokartonu',
        name: 'Montáže sádrokartonu',
        description: 'Provádíme veškeré montáže sádrokartonu',
        imageSrc: '/src/services/montaze-sadrokartonu-ukazka.webp',
        imageAlt: 'Montáže sádrokartonu v Olomouci.',
        points: [
            'Kompletní výstavba podkroví včetně podlah z fermacellu',
            'Podhledy a příčky v rodinných domech',
            'Různé desingové prvky',
            'Rozdělení velké místnosti na více jednotek příčkou',
            'Kazetové podhledy',
        ],
        links: [
            {
                name: 'Zjistit více',
                href: drywall.url(),
            },
        ],
    },
    {
        id: 'foukanou-izolaci',
        name: 'Foukaná izolace',
        description: 'Provádíme zateplení foukanou minerální izolací.',
        imageSrc: '/src/services/foukana-izolace-ukazka.webp',
        imageAlt: 'Foukaná izolace v Olomouci.',
        points: [
            'Nejvíce oceňovanou vlastností foukané izolace je její schopnost dokonale zaplnit všechny dutiny. Vzniká tak 100% izolační vrstva bez jakýchkoliv tepelných mostů.',
            'Foukaná izolace je dokonale prodyšná a vodoodpudivá. Přispívá k vytváření zdravého prostředí v domácnosti a je odolná vůči plísním a hnilobám.',
            'Foukaná izolace je levná a velice účinná. Návratnost investice je obvykle do 5 let.',
            'Minerální vata používaná na foukanou izolaci je nehořlavá a začíná se tavit až při 2000°C, což zvyšuje požární bezpečnost objektu.',
            'Při aplikaci nevzniká žádný prořez - platíte jen za skutečně využitý materiál a nemusíte řešit likvidaci odpadu.',
        ],
        links: [
            {
                name: 'Zjistit více',
                href: blownInsulation.url(),
            },
        ],
    },
    {
        id: 'betonove-sterky',
        name: 'Betonové stěrky',
        description:
            'Betonová stěrka je snadno aplikovatelná omítka imitující přírodní beton. Používá se jako designový prvek navozující industriální vzhled jakékoli stěny, koupelny, kuchyně, krbu nebo jakékoli jiné části interiéru či exteriéru.',
        imageSrc: '/src/services/betonova-sterka-ukazka.webp',
        imageAlt: 'Betonová stěrka v Olomouci.',
        links: [
            {
                name: 'Zjistit více',
                href: screed.url(),
            },
        ],
    },
]
</script>

<template>
    <section
        id="sluzby"
        aria-label="Programátorské akce zaměřené na Laravel, Inertia.js, Vue.js a Tailwind CSS"
        class="scroll-mt-32 lg:space-y-20"
    >
        <div
            v-for="(feature, featureIdx) in features"
            :key="feature.name"
            :id="feature.id"
            class="flex scroll-mt-32 flex-col gap-2 lg:grid lg:grid-cols-12 lg:flex-col-reverse lg:items-center lg:gap-x-8"
        >
            <header
                :class="[
                    featureIdx % 2 === 0 ? 'lg:col-start-1' : 'lg:col-start-8 xl:col-start-9',
                    'header-width mt-7 lg:col-span-5 lg:row-start-1 lg:mt-0 xl:col-span-4',
                ]"
            >
                <h2 class="header-h">
                    {{ feature.name }}
                </h2>
                <p class="header-p">
                    {{ feature.description }}
                </p>
                <ul
                    v-if="feature.points"
                    class="mt-4 space-y-2"
                >
                    <li
                        v-for="(point, idx) in feature.points"
                        :key="idx"
                        class="flex items-start"
                    >
                        <ArrowRightCircleIcon
                            class="relative top-0.5 mr-2 size-5 flex-shrink-0 text-green-700"
                            aria-hidden="true"
                        />
                        <p class="text-base text-gray-800">{{ point }}</p>
                    </li>
                </ul>

                <div
                    v-if="feature.links"
                    class="col-span-full mt-5 w-full space-y-2"
                >
                    <Link
                        v-for="(link, idx) in feature.links"
                        :key="idx"
                        :href="link.href"
                        class="bg-brand-orange flex cursor-pointer items-center justify-center rounded-full py-2"
                    >
                        <span class="font-chivo text-2xl text-white uppercase xl:text-3xl">
                            {{ link.name }}
                        </span>
                    </Link>
                </div>
            </header>

            <div
                :class="[
                    featureIdx % 2 === 0 ? 'lg:col-start-6 xl:col-start-5' : 'lg:col-start-1',
                    'flex flex-auto lg:col-span-7 lg:row-start-1 xl:col-span-8',
                ]"
            >
                <img
                    :src="feature.imageSrc"
                    :alt="feature.imageAlt"
                    :class="[
                        featureIdx % 2 === 0 ? 'mx-auto xl:ml-auto' : 'mx-auto xl:mr-auto',
                        'aspect-5/4 rounded-lg bg-gray-100 object-cover lg:w-10/12',
                    ]"
                />
            </div>
        </div>
    </section>
</template>
